// AP Cards JS — hover video for product cards.
// Binding is idempotent per element (so loading this asset on a page twice — e.g. lineup
// + product sections — never double-binds) and re-runs on shopify:section:load.

// Shared add-to-cart: POST variant to /cart/add.js with sections=cart-drawer, then call
// Dawn CartDrawer.renderContents() so the drawer reflects the new item without reload.
// Used by the PDP (ap-pdp.js). Cards no longer quick-add — customers pick a size on the PDP.
// Resolves to { ok: boolean, error: string|null } so callers can surface failures
// (sold-out 422s, network errors) instead of silently swallowing them.
//
// It always settles within ADD_TIMEOUT_MS: callers disable every add button until it does,
// so a request that never answers would leave the shopper with a dead gray button. Once the
// add succeeds, a drawer render failure is NOT an add failure: the item is in the bag, so the
// shopper goes to /cart instead of seeing "could not add" and adding it again.
//
// A result is final: once the time limit has answered, a late response never opens the drawer
// or navigates. After a time-out the bag is refreshed in place, because Shopify may have added
// the item although the browser gave up waiting.
//
// Tracking: apTrack publishes Shopify custom events (Customer events → custom pixel), and
// sends them to PostHog when it is on:
//   ap_add_tap    — every tap on an add control (ap-pdp.js), with has_size
//   ap_add_result — every add request, with outcome ok | error_422 | http_error |
//                   network_error | timeout | drawer_fail, status and ms
// Schema and the pixel: docs/add-to-cart-tracking.md.
//
// Diagnostics: ?apdebug=1 shows each step on screen (kept for the tab via sessionStorage;
// ?apdebug=0 turns it off). For phone browsers without a console, e.g. in-app browsers.
(function () {
  if (window.apLog) return; // asset loaded twice on one page: bind diagnostics once
  var on = false;
  try {
    var p = new URLSearchParams(location.search).get('apdebug');
    if (p === '1') sessionStorage.setItem('apdebug', '1');
    if (p === '0') sessionStorage.removeItem('apdebug');
    on = sessionStorage.getItem('apdebug') === '1';
  } catch (e) { on = /[?&]apdebug=1/.test(location.search); }
  var box = null, t0 = Date.now();
  window.apLog = function (msg) {
    if (!on) return;
    var line = '+' + (Date.now() - t0) + 'ms ' + msg;
    try { console.log('[ap] ' + line); } catch (e) {}
    if (!document.body) return;
    if (!box) {
      box = document.createElement('pre');
      // pointer-events:none: the log must never take the taps it is there to observe.
      box.setAttribute('style', 'position:fixed;top:0;left:0;right:0;z-index:2147483647;max-height:25vh;overflow:hidden;margin:0;padding:6px 8px;background:rgba(0,0,0,.75);color:#7CFC00;font:11px/1.35 monospace;white-space:pre-wrap;pointer-events:none;');
      document.body.appendChild(box);
    }
    // Newest line first: the box no longer scrolls, so keep the latest entries visible.
    box.textContent = line + '\n' + box.textContent.slice(0, 4000);
  };
  if (!on) return;
  window.addEventListener('error', function (e) { window.apLog('ERROR ' + e.message + ' @ ' + (e.filename || '').split('/').pop() + ':' + e.lineno); });
  window.addEventListener('unhandledrejection', function (e) { window.apLog('REJECTION ' + (e.reason && (e.reason.stack || e.reason.message) || e.reason)); });
  document.addEventListener('DOMContentLoaded', function () { window.apLog('ready: ' + navigator.userAgent); });
  // Every tap on a purchase control, before any handler runs (capture phase), with its state.
  // A disabled button gets no click at all, so pointerdown shows taps that click never sees.
  ['pointerdown', 'click'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var t = e.target && e.target.closest && e.target.closest('[data-ap-add-to-bag],[data-ap-size],[data-ap-sheet-size],[data-ap-pack-add],[data-ap-color]');
      if (!t) return;
      var name = t.hasAttribute('data-ap-add-to-bag') ? 'add'
        : t.hasAttribute('data-ap-sheet-size') ? 'sheet size ' + t.getAttribute('data-ap-sheet-size')
        : t.hasAttribute('data-ap-size') ? 'size ' + t.getAttribute('data-ap-size')
        : t.hasAttribute('data-ap-color') ? 'color ' + t.getAttribute('data-ap-color') : 'pack add';
      window.apLog(type + ': ' + name + (t.disabled ? ' [disabled]' : '') + (t.getAttribute('aria-busy') ? ' [busy]' : '') +
        (t.hasAttribute('data-ap-add-to-bag') ? ' variant=' + (t.getAttribute('data-ap-variant-id') || 'none') : ''));
    }, true);
  });
})();

// Context sent with every tracking event: page kind and in-app browser (Instagram/Facebook).
function apContext() {
  var ua = navigator.userAgent || '';
  var path = location.pathname;
  // Landing pages are /pages/lp-… or a product rendered with a landing template (?view=lp-…).
  var view = '';
  try { view = new URLSearchParams(location.search).get('view') || ''; } catch (e) { view = ''; }
  var isProduct = path.indexOf('/products/') === 0;
  return {
    page: path.indexOf('/pages/lp-') === 0 || (isProduct && view.indexOf('lp-') === 0) ? 'landing' : isProduct ? 'product' : 'other',
    path: path,
    in_app: /Instagram/i.test(ua) ? 'instagram' : /FBAN|FBAV|FB_IAB/.test(ua) ? 'facebook' : 'none'
  };
}
window.apTrack = function (name, data) {
  var payload = apContext();
  Object.keys(data || {}).forEach(function (k) { payload[k] = data[k]; });
  if (window.apLog) window.apLog('track ' + name + ' ' + JSON.stringify(payload));
  try {
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      window.Shopify.analytics.publish(name, payload);
    }
  } catch (e) { /* tracking must never break buying */ }
  try {
    // PostHog (snippets/ap-posthog.liquid) gets the same events, tied to the session replay.
    if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, payload);
  } catch (e) { /* same */ }
};

// Re-renders the bag drawer and header count from the server without opening the drawer.
function apRefreshBag() {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer || typeof drawer.getSectionsToRender !== 'function') return;
  var url = ((window.routes && window.routes.cart_url) || '/cart') + '.js?sections=cart-drawer,cart-icon-bubble';
  fetch(url, { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      if (!data || !data.sections) return;
      drawer.getSectionsToRender().forEach(function (s) {
        var el = s.selector ? document.querySelector(s.selector) : document.getElementById(s.id);
        var html = data.sections[s.id];
        if (el && html) el.innerHTML = drawer.getSectionInnerHTML(html, s.selector);
      });
      // Same follow-up as CartDrawer.renderContents: the overlay node was replaced.
      drawer.classList.toggle('is-empty', !drawer.querySelector('.cart-item'));
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', drawer.close.bind(drawer));
      if (window.apLog) window.apLog('bag refreshed: ' + (data.item_count != null ? data.item_count + ' items' : 'ok'));
    })
    .catch(function () {});
}

// A page restored from the back/forward cache shows the bag as it was when the shopper left;
// the cart may have changed since (another page, checkout), so re-read it.
window.addEventListener('pageshow', function (e) { if (e.persisted) apRefreshBag(); });

// Long enough for a real add on a slow phone connection; short enough that nobody waits forever.
var ADD_TIMEOUT_MS = 15000;
var ADD_TIMEOUT_MSG = 'Sorry — this is taking too long. Please check your bag, then try again.';
window.apAddToCart = function (variantId, qty, meta) {
  var log = window.apLog || function () {};
  var source = (meta && meta.source) || 'unknown';
  var started = Date.now();
  var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
  return new Promise(function (resolve) {
    var done = false, status = 0;
    function finish(ok, error, outcome) {
      if (done) return;
      done = true;
      clearTimeout(timer);
      window.apTrack('ap_add_result', { source: source, variant: String(variantId), qty: qty || 1, outcome: outcome, status: status, ms: Date.now() - started });
      resolve({ ok: ok, error: error });
    }
    var timer = setTimeout(function () {
      log('add: TIMEOUT after ' + ADD_TIMEOUT_MS + 'ms');
      if (ctrl) ctrl.abort();
      finish(false, ADD_TIMEOUT_MSG, 'timeout');
      apRefreshBag();
    }, ADD_TIMEOUT_MS);
    (async function () {
      var state;
      try {
        log('add: POST /cart/add.js id=' + variantId + ' qty=' + (qty || 1));
        var addResp = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: Number(variantId), quantity: qty || 1, sections: ['cart-drawer', 'cart-icon-bubble'], sections_url: window.location.pathname }),
          signal: ctrl ? ctrl.signal : undefined
        });
        status = addResp.status;
        log('add: HTTP ' + addResp.status);
        if (!addResp.ok) {
          // Shopify returns 422 with { description, message } for sold-out / limit errors.
          var msg = null;
          try { var ej = await addResp.json(); msg = ej.description || ej.message || null; } catch (e2) {}
          finish(false, msg, addResp.status === 422 ? 'error_422' : 'http_error');
          return;
        }
        state = await addResp.json();
        log('add: parsed; sections=' + (state.sections ? Object.keys(state.sections).join(',') : 'none'));
      } catch (e) {
        log('add: FAILED ' + (e && (e.name + ': ' + e.message)));
        finish(false, null, 'network_error');
        return;
      }
      // Timed out already: the shopper has the message and a refreshed bag. Never pop the drawer
      // or leave the page late (Safari versions that ignore the abort signal get here).
      if (done) return;
      // The item is in the bag from here on.
      try {
        // Not upgraded yet (cart-drawer.js still loading or failed) counts as a drawer failure:
        // the bag page always shows the item.
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function') throw new Error('cart drawer not ready');
        // A size sheet or size guide still open as a modal (e.g. another landing-page section's)
        // would sit above the drawer and make it untappable.
        Array.prototype.forEach.call(document.querySelectorAll('dialog[open]'), function (d) {
          if (typeof d.close === 'function') d.close();
        });
        drawer.renderContents(state);
        log('add: drawer rendered');
      } catch (e) {
        log('add: drawer FAILED ' + (e && (e.name + ': ' + e.message)) + ' → /cart');
        finish(true, null, 'drawer_fail');
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        return;
      }
      finish(true, null, 'ok');
    })();
  });
};

(function () {
  // Lazy hover video for product cards: play (muted, inline) on enter, pause+reset on leave.
  function bindHover(media) {
    if (media.dataset.apHover) return;
    media.dataset.apHover = '1';
    var v = media.querySelector('video[data-card-video]');
    if (!v) return;
    media.addEventListener('mouseenter', function () {
      v.muted = true; v.playsInline = true;
      var p = v.play(); if (p && p.catch) p.catch(function () {});
    });
    media.addEventListener('mouseleave', function () {
      try { v.pause(); v.currentTime = 0; } catch (e) {}
    });
  }

  function boot() {
    document.querySelectorAll('.ap-card__media').forEach(bindHover);
  }

  if (document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
